// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__D1ANc","rotation":"styles_rotation__EZ330"};